import { Link } from './Link.js';

export default Link;
